<template>
  <div>
    <b-row class="user-background"></b-row>
    <hr class="hr-form-el-separator">

    <div v-if="loading" class="m-loader">
    	<div class="m-loader-icon-holder">
    		<i class="m-loader-icon"></i>
    		<p></p>
    	</div>
    </div>
    <div v-else-if="userNotFound" class="container">
      <b-row>
        <b-col>
          <div class="no-user-container">
            <p>User Not Found</p>
            <img :src="noUserFoundIcon"></img>
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-else class="container">
      <b-row class="mt-3 mb-4 user-data-container">

        <!-- ### RIGHT SIDE -->
        <b-col lg="3" md="4" sm="4" class="user-details-column">
          <!-- avatar -->
          <b-row class="avatar-row">
            <md-avatar class="mo-avatar-user">
              <img v-if="imageUrl" :src="imageUrl" />
              <img v-else :src="avatarPlaceholder" />
            </md-avatar>
          </b-row>
          <!-- verified info -->
          <b-row>
            <div class="side-table-container">
              <b-row class="mo-table-header">
                <b-col lg="8">Verified Info</b-col>
              </b-row>
              <b-row class="mo-table-row">
                <b-col lg="8">Email Address</b-col>
                <b-col v-if="isEmailVerified" lg="2"><div class="mo-check-icon"></div></b-col>
                <b-col v-else lg="2"><div class="mo-no-check"></div></b-col>
              </b-row>
              <b-row class="mo-table-row last">
                <b-col lg="8">Phone Number</b-col>
                <b-col v-if="isPhoneProvided" lg="2"><div class="mo-check-icon"></div></b-col>
                <b-col v-else lg="2"><div class="mo-no-check"></div></b-col>
              </b-row>
            </div>
          </b-row>
          <!-- linked accounts -->
          <b-row class="mt-3">
            <div class="side-table-container">
              <b-row class="mo-table-header"><b-col>Linked accounts</b-col></b-row>
              <b-row class="mo-table-row">
                <b-col lg="8">Google</b-col>
                <b-col v-if="googleLinked" lg="2"><div class="mo-check-icon"></div></b-col>
                <b-col v-else lg="2"><div class="mo-no-check"></div></b-col>
              </b-row>
              <b-row class="mo-table-row">
                <b-col lg="8">Facebook</b-col>
                <b-col v-if="facebookLinked" lg="2"><div class="mo-check-icon"></div></b-col>
                <b-col v-else lg="2"><div class="mo-no-check"></div></b-col>
              </b-row>
              <b-row class="mo-table-row last">
                <b-col v-if="isLinkedInProvided" lg="8"><a :href="linkedIn" target="_blank">LinkedIn</a></b-col>
                <b-col v-else lg="8">LinkedIn</b-col>
                <b-col v-if="isLinkedInProvided" lg="2"><div class="mo-check-icon"></div></b-col>
                <b-col v-else lg="2"><div class="mo-no-check"></div></b-col>
              </b-row>
            </div>
          </b-row>
          <!-- about user -->
          <b-row class="mt-3">
            <div class="side-table-container">
              <b-row class="mo-table-header"><b-col>About Me</b-col></b-row>
              <b-row class="mo-table-row">
                <b-col>
                  <b>Work</b><br>
                  {{workplace}}
                </b-col>
              </b-row>
              <b-row class="mo-table-row last">
                <b-col>
                  <b>Languages</b><br>
                  {{prefLanguage}}
                </b-col>
              </b-row>
            </div>
          </b-row>
        </b-col>


        <!-- ### LEFT SIDE -->
        <b-col lg="8" md="7" sm="7" class="user-desc-column intro-column">
          <b-row><h1>Hey, I'm {{firstName}}</h1></b-row>
          <b-row><h4>{{currentlyBased}}</h4></b-row>

          <b-row class="user-desc-container">
            <b-col>
              <div class="text-note">
                <pre>{{userDescription}}</pre>
              </div>
            </b-col>
          </b-row>

          <hr class="hr-form-el-separator">

          <b-row class="user-stats-container">
            <b-col v-if="verifiedUser">
              <div class="icon-text-container">
                <div class="mo-verified"></div><span>Verified</span>
              </div>
            </b-col>
          </b-row>
        </b-col>

      </b-row>
    </div>
  </div>
</template>
<script>
  import {
    getUserPublicByMaaklerId,
    getUserPublicByUId
  } from '../functions.js'
  import {
    isUserMoowleVerified
  } from '../users/repositories/userRepository.js'
  export default {
    props: {
    },
    name: 'user',
    data() {
      return {
        loading: false,
        loadingText: '',
        firstName: '',
        imageUrl: '',
        isEmailVerified: false,
        isLinkedInProvided: false,
        isPhoneProvided: false,
        userDescription: 'User hasn\'t set any description',
        currentlyBased: '',
        linkedIn:'',
        googleLinked: false,
        facebookLinked: false,
        userNotFound: false,
        prefLanguage: '',
        workplace:'',
        verifiedUser: false
      }
    },
    computed:{
      avatarPlaceholder(){
        return require('../assets/avatar.png')        
      },
      noUserFoundIcon() {
        return require('../assets/404_user.svg')
      }
    },
    created() {
      console.log('this.$route.query.id:', this.$route.query.id);
      
      this.loading = true
      var userMaaklerId = this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1)
      var userPromise
      if(userMaaklerId && !isNaN(userMaaklerId)) userPromise = getUserPublicByMaaklerId(userMaaklerId)
      else if(this.$route.params.id) userPromise = getUserPublicByUId(this.$route.params.id)
      if(!userPromise) {
        this.redirectTo({ where: "dashboard" })
        return
      }
      userPromise.then(userPublic => {
          if(!userPublic) this.userNotFound = true
          else{
            this.userNotFound = false
            userPublic.pictureUrl?this.imageUrl=userPublic.pictureUrl:void 0;
            if(userPublic.emailVerified == true) this.isEmailVerified=userPublic.emailVerified
            if(userPublic.googleLinked == true) this.googleLinked=userPublic.googleLinked
            if(userPublic.facebookLinked == true) this.facebookLinked=userPublic.facebookLinked

            let phoneNr = userPublic.phone
            if(phoneNr && phoneNr != '' && phoneNr != 'null') this.isPhoneProvided = true
            userPublic.firstName?this.firstName = userPublic.firstName:void 0
            userPublic.description?this.userDescription=userPublic.description:void 0
            userPublic.currentlyBased?this.currentlyBased = userPublic.currentlyBased:void 0
            userPublic.linkedInPublicUrl?this.isLinkedInProvided = true:this.isLinkedInProvided = false;
            userPublic.linkedInPublicUrl?this.linkedIn = userPublic.linkedInPublicUrl:void 0
            userPublic.prefLanguage?this.prefLanguage=userPublic.prefLanguage:void 0
            userPublic.workplace?this.workplace=userPublic.workplace:void 0

            this.verifiedUser = isUserMoowleVerified(userPublic)
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.userNotFound = true
        })
    },
    methods: {
      redirectTo({ where, params }) {
        this.$router.push({
          name: where,
          params: params
        });
      },
    }
  }

</script>
<style>
  @import '../assets/styles/global.css';
  @import '../assets/styles/user.css';

  .user-background{
    background: url('../assets/sanfran.svg') no-repeat;
    background-position: center;
    background-size: cover;
    height: 30vh;
  }

  .avatar-uploader .el-upload {
    border: 1px solid #d9d9d9;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader .el-upload:hover .avatar-overhover{
    display: inline;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }

  .avatar {
    border-radius: 150px;
    width: 150px;
    height: 150px;
    /* display: block; */
  }
  .avatar-overhover{
    display: none;
    position: absolute;
    background-color: rgb(255,255,255,0.6);
  }

  .change-avatar-peek{
    position: absolute;
    z-index: 9999;
    top: 45%;
    left: 43%;
  }

  /*  from infinity to max 700 and then this kicks in*/
  @media (max-width: 1000px) {
    .user-data-container{
      padding:1.5em;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/User.vue